<template>
    <div>
        <!--轮播图-->
        <el-carousel
                v-show="hxCarouseList.length > 0"

                :height="carouselHeight"
                :interval="5000"
                @change="carouselChange"
        >
            <el-carousel-item v-for="(item, index) in hxCarouseList" :key="index">
                <div class="carousel-item">
                    <div v-if="initialIndex === index" class="carousel-text">
                        <div
                                class="animate__animated animate__slideInDown carousel-text-title"
                        >
                            {{ item.title }}
                        </div>
                        <div
                                class="animate__animated animate__fadeInLeftBig fsCont"
                                style="color: #fff; "
                        >
                            {{ item.content }}
                        </div>
                        <el-button
                                @click="jump(item.buttonUrl)"
                                v-if="item.isButton === '1'"
                                class="animate__animated animate__fadeInUp"
                                type="primary"
                                :size="butSize"
                        >
                            {{ item.buttonText }}
                        </el-button>
                    </div>
                    <el-image
                            style="width: 100%; z-index: -9"
                            :style="{ height: carouselHeight }"
                            :src="item.url"
                    ></el-image>
                </div>
            </el-carousel-item>
        </el-carousel>
        <!--        <div >-->
        <!--            <div>kkk</div>-->
        <!--            <div>xxx</div>-->
        <!--        </div>-->
        <div
                :id="'menu' + index"
                v-for="(item, index) in hxClassifyList"
                :key="index"
                class="animate__animated animate__fadeInUp about-us"
        >
            <div class="about-us-title">
                {{ item.title }}
            </div>
            <div class="about-us-option"/>
            <div class="about-us-line"></div>
            <div class="about-us-subtitle" v-if="item.subtitle">
                {{ item.subtitle }}
            </div>

            <div v-if="item.hxContentList.length > 0" class="bigContent" style="">
                <!--普通类型-->
                <!--                <div >-->
                <Ordinary v-if="item.hxContentList[0].type === '1'" :hxContentList="item.hxContentList"></Ordinary>
                <!--                </div>-->

                <!--                <div>-->
                <Tabs v-if="item.hxContentList[0].type === '2'" :hxContentList="item.hxContentList"></Tabs>
                <!--                </div>-->

<!--                <div >-->
                    <MyVideo v-if="item.hxContentList[0].type === '3'" :hxContentList="item.hxContentList"></MyVideo>
<!--                </div>-->

                <div v-if="item.hxContentList[0].type === '4'" class="container">
                    <!--客户卡片-->
                    <el-row class="client" v-if="item.hxContentList[0].compose === '4'" :gutter="20"
                            style="margin: 0 auto;overflow-y: hidden;display: flex;flex-wrap: wrap">
                        <el-col
                                class="col"
                                :xs="12"
                                :sm="6"
                                :md="4"
                                :lg="4"
                                :xl="4"
                                v-for="(item2, index2) in item.hxContentList"
                                :key="index2"

                        >
                            <div class="grid-content custom" style="margin: 0 auto;">
                                <el-image
                                        style="
                    width: 150px;
                    height: 150px;
                  "
                                        :src="item2.url"
                                ></el-image>
                                <!--                                box-shadow: 7px 7px 13px -1px rgba(0, 0,0, 0.2);-->

                            </div>
                        </el-col>
                    </el-row>
                    <!--知识问答-->
<!--                    <div >-->
                        <OrdinaryList v-if="item.hxContentList[0].compose === '1'" :hxContentList="item.hxContentList"></OrdinaryList>
<!--                    </div>-->
                    <!--我的团队-->
<!--                    <el-row :gutter="20">-->
                        <ShadowList  v-if="item.hxContentList[0].compose === '2'"  :hxContentList="item.hxContentList"></ShadowList>
<!--                    </el-row>-->
                    <!--上图下标题-->
                    <div v-if="item.hxContentList[0].compose === '3'">
                        <Card :hxContentList="item.hxContentList"></Card>
                    </div>

                </div>


<!--                <div v-if="item.hxContentList[0].type === '4'&&item.hxContentList[0].compose !== '4'"-->
<!--                     class="about-us-content">-->
<!--                    &lt;!&ndash;知识问答&ndash;&gt;-->
<!--                    <div v-if="item.hxContentList[0].compose === '1'">-->
<!--                        <OrdinaryList :hxContentList="item.hxContentList"></OrdinaryList>-->
<!--                    </div>-->
<!--                    &lt;!&ndash;我的团队&ndash;&gt;-->
<!--                    <el-row v-if="item.hxContentList[0].compose === '2'" :gutter="20">-->
<!--                        <ShadowList :hxContentList="item.hxContentList"></ShadowList>-->
<!--                    </el-row>-->
<!--                    &lt;!&ndash;上图下标题&ndash;&gt;-->
<!--                    <div v-if="item.hxContentList[0].compose === '3'">-->
<!--                        <Card :hxContentList="item.hxContentList"></Card>-->
<!--                    </div>-->

<!--                </div>-->

                <div style="width: 100%;" v-if="item.hxContentList[0].type === '5'">
                    <SingleRotation :hxContentList="item.hxContentList"></SingleRotation>
                </div>

                <div style="width: 100%;" v-if="item.hxContentList[0].type === '6'">
                    <MultiRotation :hxContentArr="item.hxContentArr"
                                   :hxContentList="item.hxContentList"></MultiRotation>
                </div>

                <!--联系我们-->
                <div class="about-us-content" v-if="item.hxContentList[0].type === '7'">
                    <ContactUs :hxContentList="item.hxContentList"></ContactUs>
                </div>


                <News v-if="item.hxContentList[0].type === '8'" :hxContentList="item.hxContentArr"
                      v-model="newsImageUrl"></News>
                <!--                    <el-row>-->
                <!--                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">-->
                <!--                            <div class="grid-content about-us-content-image ">-->
                <!--                                &lt;!&ndash;                                <el-image&ndash;&gt;-->
                <!--                                &lt;!&ndash;                                        style="width: 100%; height: 400px"&ndash;&gt;-->
                <!--                                &lt;!&ndash;                                        :src="newsImageUrl"&ndash;&gt;-->
                <!--                                &lt;!&ndash;                                        class="scal"&ndash;&gt;-->
                <!--                                &lt;!&ndash;                                ></el-image>&ndash;&gt;-->
                <!--                                <div>-->
                <!--                                    <img class="scal" :src="newsImageUrl">-->
                <!--                                </div>-->
                <!--                            </div>-->
                <!--                        </el-col>-->

                <!--                        <el-col clall="col" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">-->
                <!--                            <el-carousel-->
                <!--                                    indicator-position="outside"-->
                <!--                                    height="350px"-->
                <!--                                    :interval="5000"-->
                <!--                                    style="padding: 0 20px"-->
                <!--                            >-->
                <!--                                <el-carousel-item-->
                <!--                                        v-for="(item2, index2) in item.hxContentArr"-->
                <!--                                        :key="index2"-->
                <!--                                >-->
                <!--                                    <div-->
                <!--                                            class="news-list"-->
                <!--                                            style="display: flex; margin: 15px 0"-->
                <!--                                            v-for="(item3, index3) in item2"-->
                <!--                                            :key="index3"-->
                <!--                                    >-->
                <!--                                        <div-->
                <!--                                                class="news-item"-->
                <!--                                                @click="newsClick(item3.url)"-->
                <!--                                        >-->
                <!--                                            <div-->
                <!--                                                    v-if="item3.sun"-->
                <!--                                                    class="sun"-->
                <!--                                            >-->
                <!--                                                {{ item3.sun }}-->
                <!--                                            </div>-->
                <!--                                            <div-->
                <!--                                                    class="calendar"-->
                <!--                                                    v-if="item3.calendar"-->
                <!--                                            >-->
                <!--                                                {{ item3.calendar }}-->
                <!--                                            </div>-->
                <!--                                        </div>-->

                <!--                                        <div class="news" style="margin-left: 20px;overflow: hidden">-->
                <!--                                            <div-->
                <!--                                                    v-if="item3.title"-->
                <!--                                                    @click="newsContent(item3)"-->
                <!--                                                    class="news-title"-->
                <!--                                            >-->
                <!--                                                {{ item3.title }}-->
                <!--                                            </div>-->
                <!--                                            <div-->
                <!--                                                    class="ql-editor news-content firstLine"-->
                <!--                                                    v-if="item3.content"-->
                <!--                                                    v-html="item3.content"-->

                <!--                                            ></div>-->
                <!--                                        </div>-->
                <!--                                    </div>-->
                <!--                                </el-carousel-item>-->
                <!--                            </el-carousel>-->
                <!--                        </el-col>-->
                <!--                    </el-row>-->

            </div>
        </div>
    </div>
</template>

<script>
    import {listEnableHxCarouse} from "@/api/carousel";
    import {listEnableHxClassifyVo} from "@/api/classify";
    import Tabs from "@/components/tabs/index";
    import MyVideo from "@/components/my-video/index";
    import Ordinary from "@/components/ordinary/index";
    import OrdinaryList from "@/components/ordinary-list/index";
    import ShadowList from "@/components/shadow-list/index";
    import ContactUs from "@/components/contact-us/index";
    import MultiRotation from "@/components/multi-rotation/index";
    import SingleRotation from "@/components/single-rotation/index";
    import Card from "@/components/card/index";
    import News from '@/components/news/myNews'
    import _ from "lodash";

    export default {
        name: "main-index",
        components: {
            Tabs,
            Ordinary,
            OrdinaryList,
            ContactUs,
            ShadowList,
            Card,
            News,
            MultiRotation,
            SingleRotation,
            MyVideo
        },
        data() {
            return {
                // 轮播图索引
                initialIndex: 0,
                // 当前宽度
                screenWidth: null,
                // 轮播图高度
                carouselHeight: "600px",
                butSize: "medium",

                hxCarouseList: [],
                hxClassifyList: [],

                activeName: "0",

                // 新闻图片路径
                newsImageUrl: "",
            };
        },
        mounted() {
            // 获取当前的宽度
            this.screenWidth = document.body.clientWidth;
            window.onresize = () => {
                return (() => {
                    this.screenWidth = document.body.clientWidth;
                })();
            };
        },
        created() {
            // 获取轮播图数据
            listEnableHxCarouse().then((response) => {
                this.hxCarouseList = response.rows;
            });

            // 获取分类数据
            listEnableHxClassifyVo().then((response) => {
                response.rows.forEach((item) => {
                    if (item.hxContentList.length > 0) {
                        if (item.hxContentList[0].type === "6") {
                            item.hxContentArr = _.chunk(item.hxContentList, 3);
                        }

                        if (item.hxContentList[0].type === "8") {
                            this.newsImageUrl = item.hxContentList[0].url;
                            item.hxContentList.forEach((item2) => {
                                item2.calendar = item2.time.substring(0, 7);
                                item2.sun = item2.time.substring(8, item2.time.length);
                            });
                            item.hxContentArr = _.chunk(item.hxContentList, 3);
                        }

                        if (item.hxContentList[0].type === "2") {
                            item.hxContentList.forEach((item2) => {
                                if (item2.optionTitle.length > 5) {
                                    item2.optionPhoneTitle =
                                        item2.optionTitle.substring(0, 5) + "...";
                                } else {
                                    item2.optionPhoneTitle = item2.optionTitle;
                                }
                            });
                        }
                    }
                });
                this.hxClassifyList = response.rows;
            });
        },
        methods: {
            newsClick(url) {
                this.newsImageUrl = url;
            },
            // 按钮跳转
            jump(url) {
                window.open(url);
            },
            // 获取轮播图索引
            carouselChange(e) {
                this.initialIndex = e;
            },
        },
        watch: {
            // 监视当前宽度变化
            screenWidth: {
                handler: function (val) {
                    if (!val) {
                        return;
                    }
                    if (val <= 570) {
                        this.carouselHeight = "250px";
                        this.butSize = "mini";
                    } else if (val >= 570 && val <= 870) {
                        this.carouselHeight = "350px";
                        this.butSize = "small";
                    } else {
                        this.carouselHeight = "600px";
                    }
                },
            },
        },
    };
</script>
<style lang="scss">


</style>
<style lang="scss" scoped>
    .container {
        width: 70%;
    }

    .bigContent {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .news-content {
        font-size: 14px;
        color: #999;
        line-height: 22px;
        margin-top: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        padding: 0;
    }

    .news-title {
        color: #0094ff;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    .news-item {
        background: #0094ff;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 90px;
        height: 90px;
        flex-shrink: 0;
    }

    .scal {
        overflow: hidden;

        img {
            transition: all .3s;
        }

        &:hover img {
            transform: scale(1.1);
        }
    }

    .contactUs {
        color: #333;
    }

    /*首行缩进*/
    .firstLine {
        text-indent: 2em;
        line-height: 28px;
    }

    .el-image {

        img {
            height: 100%;
            width: 100%;
            transition: all .3s;
        }

        &:hover img {
            transform: scale(1.1);
        }

    }

    .ql-editor {
        padding: 0 0 !important;
    }

    .el-dialog {
        width: 30%;
        background-color: transparent !important;
    }

    .news-list {
        cursor: pointer;
        transition: 0.5s;

        &:hover {
            transform: translateY(-4px);
        }
    }

    .el-dialog__body {
        background: transparent;
    }


    .select-text {
        position: absolute;
        right: 0;
        z-index: 9;
        width: 300px;
        background: #0094ff;
        top: 10px;
        padding: 10px;
    }

    .box-card {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .card {
        margin-top: 10px;
        overflow: hidden;
        font-size: 14px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        color: #666;
        /*width: 90%;*/
        padding: 0 15px !important;
    }

    .box {
        position: relative;
        width: 250px;
        height: 300px;
        background: #000;
        box-shadow: 0 30px 30px rgba(0, 0, 0, 0.5);
    }

    .box .imgBx {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .box .imgBx img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: 0.5s;
    }

    .box:hover .imgBx img {
        opacity: 0;
    }

    .box .content {
        position: absolute;
        bottom: 20px;
        left: 10%;
        width: 80%;
        height: 60px;
        background: #fafafa;
        transition: 0.5s;
        overflow: hidden;

        padding: 15px;
        box-sizing: border-box;
    }

    .box:hover .content {
        width: 100%;
        height: 100%;
        bottom: 0;
        left: 0;
    }

    .box .content h3 {
        margin: 0;
        padding: 0;
        font-size: 20px;
        text-align: center;
    }

    .box .content p {
        margin: 10px 0 0;
        padding: 0;
        opacity: 0;
        line-height: 1.6em;
        transition: 0.5s;
        text-align: justify;
    }

    .box .content p a {
        color: #222;
        text-decoration: none;
    }

    .box:hover .content p {
        opacity: 1;
        transition-delay: 0.5s;
    }

    .custom {
        /*padding: 0 20px;*/
        display: flex;
        justify-content: center;
        transition: 0.5s;
        overflow-y: hidden;
        /*box-shadow: 0 15px 30px  rgba(0, 0, 0, .4);*/
        &:hover {
            transform: translateY(-20px);
            cursor: pointer;
        }
    }

    .col {
        margin-top: 20px;
    }

    .bold {
        font-weight: bold;
    }

    .about-us {
        display: flex;
        width: 100%;
        justify-content: center;
        margin: 30px 0;
        flex-direction: column;
        align-items: center;
        overflow-x: hidden;

        .about-us-title {
            font-size: 30px;
            color: #333;
        }

        .about-us-option {
            width: 100px;
            height: 6px;
            background: #0094ff;
            margin-top: 20px;
            border-radius: 4px;
        }

        .about-us-line {
            width: 100%;
            height: 1px;
            background: #ddd;
            margin-bottom: 20px;
        }

        .about-us-subtitle {
            margin-top: 20px;
            color: #999;
            font-size: 12px;
            margin-bottom: 10px;
        }

        .about-us-content {
            padding: 20px 0;
            // width: 65%;
            .about-us-content-image {
                display: flex;
                justify-content: center;
            }

            .about-us-content-title {
                display: flex;
                flex-direction: column;
                //   width: 100%;

                .about-us-content-title-text {
                    // font-weight: bold;
                    color: #333;
                    font-size: 18px;
                    width: 350px;
                }

                .about-us-content-title-subtitl {
                    font-size: 14px;
                    padding: 10px 0;
                    line-height: 26px;
                    color: #999;

                    // width: 350px;
                }

                .about-us-content-title-content {
                    color: #333;
                    font-size: 14px;
                    line-height: 26px;
                    word-wrap: normal;
                    // width: 320px;
                    overflow-x: hidden;
                    margin: 10px 0;
                }
            }
        }
    }

    .carousel-item {
        position: relative;

        .carousel-text {
            z-index: 99;
            position: absolute;
            top: 40%;
            left: 10%;

            .carousel-text-title {
                color: #fff;
                font-weight: bold;
            }
        }
    }

    @media screen and (min-width: 1500px) {

        .container {
            width: 70%;


        }

        .about-us-content {
            width: 65%;
        }
    }

    @media screen and (min-width: 1200px) {
        .container {
            width: 70%;
        }

        .news-item {
            width: 90px;
            height: 90px;
        }

        .carousel-text-title {
            font-size: 40px;
        }

        .about-us-content-title {
            margin-left: 50px;
        }

        .about-us-content {
            width: 75%;
        }

        /*.news::-webkit-scrollbar {*/
        /*    width: 0px;*/
        /*}*/
        /*.news::-webkit-scrollbar-thumb {*/
        /*    display: none;*/
        /*}*/
        .select-image {
            height: 400px;
        }

        .about-us-content-title-content p {
            // width: 450px;
        }
        .fsCont {
            width: 420px;
            margin: 20px 0px;
        }

        .scal {
            width: 100%;
            height: 350px;
        }

        .sun {
            font-size: 20px;
            color: white;
        }

        .calendar {
            font-size: 16px;
            color: white
        }

        .news-title {
            font-size: 16px;
        }
    }

    @media screen and (max-width: 1200px) {
        .container {
            width: 70%;
        }

        .news-item {
            width: 90px;
            height: 90px;
        }

        .carousel-text-title {
            font-size: 40px;
        }

        .about-us-content-title {
            margin-left: 50px;
        }

        .about-us-content {
            width: 90%;
        }

        .select-image {
            height: 400px;
        }

        .about-us-content-title-content p {
            // width: 450px;
        }
        .fsCont {
            width: 400px;
            margin: 20px 0px;
        }

        .scal {
            width: 100%;
            height: 350px;
        }

        .sun {
            font-size: 20px;
            color: white;
        }

        .calendar {
            font-size: 16px;
            color: white
        }

        .news-title {
            font-size: 16px;
        }
    }

    @media screen and (max-width: 870px) {
        .container {
            width: 70%;
        }

        .news-item {
            width: 90px;
            height: 90px;
        }

        .fsCont {
            font-size: 14px;
            width: 300px;
            margin: 20px 0px;

        }
        .carousel-text-title {
            font-size: 25px;
        }

        .about-us-content-title {
            margin-left: 50px;
            margin-top: 20px;
        }

        .input {
            width: 98%;
        }

        .about-us-content {
            width: 90%;
        }

        .select-image {
            height: 200px;
        }

        .select-text {
            top: 50%;
            width: 100%;
            height: 250px;
        }

        .about-us-content-title-content p {
            // width: 450px;
        }
        .mt20 {
            margin-top: 20px;
        }

        .scal {
            width: 100%;
            height: 300px;
        }

        .sun {
            font-size: 18px;
            color: white;
        }

        .calendar {
            font-size: 14px;
            color: white
        }

        .news-title {
            font-size: 16px;
        }

        .news {
            width: 80%;
        }
    }

    @media screen and (max-width: 570px) {
        .container {
            width: 90%;
        }

        .news-item {
            width: 70px;
            height: 70px;
        }

        .fsCont {
            font-size: 12px;
            margin: 10px 0px;

        }
        .carousel-text-title {
            font-size: 20px;
        }

        .about-us-content-title {
            margin-left: 20px;
            margin-top: 20px;
        }

        .input {
            width: 92%;
        }

        .about-us-content {
            width: 100%;
        }

        .select-image {
            height: 200px;
        }

        .select-text {
            top: 50%;
            width: 100%;
            height: 250px;
        }

        .box {
            width: 350px;
            height: 400px;
        }

        .card {
            width: 150px;
            font-size: 12px;
        }

        .about-us-content-title-content p {
            // width: 320px;
        }

        .scal {
            width: 100%;
            height: 200px;
        }

        .sun {
            font-size: 16px;
            color: white;
        }

        .calendar {
            font-size: 12px;
            color: white
        }

        .news-title {
            font-size: 14px;
        }

        .news {
            width: 80%;
        }
    }
</style>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
